import {useDispatch} from 'react-redux'

import {redirectUsersFromCallbackUrl} from '../modules/thunks'
import {removeLastLoginUrl} from '../business/persistData'

export const CognitoLogoutHandler = () => {
  const dispatch = useDispatch()
  dispatch(redirectUsersFromCallbackUrl())
  removeLastLoginUrl()
  return null
}
